import { useTranslation } from 'next-i18next'
import React from 'react'

import ContentfulImageLink from '@src/quince-site-common/src/domains/contentful/ContentfulImageLink'
import ContentfulLink from '@src/quince-site-common/src/domains/contentful/ContentfulLink'
import ImageDomain from '@src/quince-site-common/src/domains/Image'

import { Link } from '..'
import { Image } from '../image'

export interface SocialBoxProps {
  footerSocial: ContentfulImageLink[]
}

const SocialBox = (props: SocialBoxProps) => {
  const { t } = useTranslation('common')

  return (
    <div className="column-gap--2">
      {props.footerSocial.map(fs => {
        const socialLabel = fs?.link?.text ?? fs?.images?.[0]?.title ?? t('social_media')
        return (
          <Link
            href={ContentfulLink.getLinkPath(fs.link)}
            key={fs.link.text}
            target="_blank"
            aria-label={t('visit_us_on_social', { socialPlatform: socialLabel })}
          >
            <Image
              url={ImageDomain.fromContentful(fs.images[0]).url}
              title=""
              useNative
              alt=""
              width={24}
              height={24}
            />
          </Link>
        )
      })}
    </div>
  )
}

export default SocialBox
